import { render } from "./audioPlayer2.vue?vue&type=template&id=3733928e&scoped=true"
import script from "./audioPlayer2.vue?vue&type=script&lang=js"
export * from "./audioPlayer2.vue?vue&type=script&lang=js"

import "./audioPlayer2.vue?vue&type=style&index=0&id=3733928e&lang=scss&scoped=true"
import "./audioPlayer2.vue?vue&type=style&index=1&id=3733928e&lang=scss"
script.render = render
script.__scopeId = "data-v-3733928e"

export default script